import { root, id } from './offline-image';

export const offlineImage = {
  ...root,
  id,
};
